import styled from '@/styles';

// Matches the header's CloseButton styling so the "?" sits naturally beside it.
const HelpButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 4,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

// Hand-rolled circle-question icon, matching XIcon's stroke conventions.
const HelpIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1C1C1C"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 24, height: 24 }}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

type HelpTourButtonProps = {
  onClick: () => void;
};

// The `data-tour` anchor lets the tour's closing step point back at this button.
const HelpTourButton = ({ onClick }: HelpTourButtonProps) => (
  <HelpButton
    type="button"
    onClick={onClick}
    aria-label="Help"
    title="Take a tour of this step"
    data-tour="orderflow-help"
  >
    <HelpIcon />
  </HelpButton>
);

export default HelpTourButton;
